import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Outlet, Navigate } from "react-router-dom";
import { getToken } from "./auth-helpers";

const PrivateRoute = ({ children, roles }) => {
  const { admin, authLoader } = useSelector((state) => state.auth);
  const adminType = admin?.adminType;

  // useEffect(() => {
  //   setIsAuthenticated(adminType);
  // }, [adminType]);

  if (authLoader) {
    return "xx0xxå";
  }

  if (!adminType) {
    return <Navigate to="/login" />;
  }

  if (roles && roles.length > 0 && !roles.includes(admin?.admin_section_id)) {
    return <Navigate to="/" />;
  }

  return <Outlet />;
};

export default PrivateRoute;
